<div class="participant-container">
  <!-- Recipient-specific template -->
  <div *ngIf="isRecipient" class="participant-header">
    <mat-icon *ngIf="isRecipientAwaitingEnisSync" [ngClass]="[pair ? 'icon-right' : 'icon', recipient?.transplanted ? 'transplanted' : '']"></mat-icon>
    <mat-icon *ngIf="!isRecipientAwaitingEnisSync" [ngClass]="[pair ? 'icon-right' : 'icon', recipient?.transplanted ? 'transplanted' : '']" svgIcon="human-{{ recipient?.gender === 'M' ? 'male' : 'female' }}"></mat-icon>
    <div class="participant-details">
      <p class="name">
        <span>
          <a *ngIf="dialogRef && !recipient?.historical" [routerLink]="['/participants']" [queryParams]="{ expandId: recipient?.id }" (click)="closeDialog()">{{ recipient?.firstName }} {{ recipient?.lastName }}</a>
          <a *ngIf="!dialogRef || recipient?.historical" [routerLink]="['/history/recipient', recipient?.id]" (click)="closeDialog()">{{ recipient?.firstName }} {{ recipient?.lastName }}</a>
          <p class="type" *ngIf="history">Recipient</p>
        </span>
      </p>
      <p class="type" *ngIf="recipient && !history">Recipient</p>
      <p *ngIf="recipient?.enisNumber ">
        <label>ET Number</label>
        {{ recipient?.enisNumber }}
      </p>


      <p *ngIf="recipient?.center">
        <label>Center</label>
        {{ recipient?.center?.name }}
      </p>
      <p>
        <label>Date of birth</label>
        {{ recipient?.dob | date: "d MMM y" }}
        <span class="age">({{ age }} years old)</span>
      </p>

      <p *ngIf="recipient?.urgency && recipient?.abo">
        <label>Blood group / Ki-Urgency</label>
        {{ recipient?.abo }} / {{ recipient?.urgency }}
      </p>
      <p *ngIf="recipient?.abo && !recipient?.urgency">
        <label>Blood group</label>
        {{ recipient?.abo }}
      </p>
      <p *ngIf="recipient?.abPhenotype">
        <label>HLA Class I</label>
        {{ recipient?.abPhenotype }}
      </p>
      <p *ngIf="recipient?.drPhenotype">
        <label>HLA Class II</label>
        {{ recipient?.drPhenotype }}
      </p>
      <p *ngIf="recipient?.dateFirstDialysis">
        <label>Date first dialysis</label>
        {{ recipient?.dateFirstDialysis | date: "d MMM y" }}
      </p>
      <p *ngIf="recipient?.unacceptables">
        <label>Unacceptables</label>
        {{ recipient?.unacceptables }}
      </p>
      <p *ngIf="recipient?.dateScreening">
        <label>Last screening</label>
        {{ recipient?.dateScreening | date: "d MMM y" }}
      </p>
      <p *ngIf="recipient?.primaryDiagnosis">
        <label>Primary diagnosis</label>
        {{ recipient?.primaryDiagnosis }}
      </p>
<!-- Used to be called previousPRA but it was just previous in our excel import. The assumption was that this was about pra as it was next to vpra, but this meant previous wait time instead-->
<!--We still call it previousPRA here as we otherwise have to make lots of changes to the database so this is fine-->      
      <p *ngIf="recipient?.previousPRA">
        <label>Returned waiting days</label>
        {{ recipient?.previousPRA }}
      </p>
      <p *ngIf="recipient?.virtualPRA !== null && recipient?.virtualPRA !== undefined">
        <label>Current vPRA</label>
        {{ recipient?.virtualPRA }}%
      </p>
      <p *ngIf="(recipient?.virtualPRA === null || recipient?.virtualPRA === undefined) && recipient?.unacceptables === ''">
        <label>Current vPRA</label>
        0%
      </p>

      <!-- Privileges Section -->
            <p *ngIf="recipient?.priority">
        <label><span class="privilege-indicator"></span>Priority</label>
        Yes
      </p>

      <p *ngIf="age < 18">
        <label><span class="privilege-indicator"></span>Children Extra Wait Time</label>
        Yes
      </p>

      <p *ngIf="recipient?.maxDonorAge">
        <label><span class="privilege-indicator"></span>Max Donor Age</label>
        {{ recipient?.maxDonorAge }}
      </p>
      <p *ngIf="recipient?.maxDonorAgeWarningDismissed && recipient?.maxDonorAgeWarningDismissalReason" class="warning-dismissal-reason">
        <label matTooltip="This recipient has max donor age privilege but is not in a compatible pair or younger than 18">Max donor age reason:</label>
        {{ recipient?.maxDonorAgeWarningDismissalReason }}
      </p>

      <p *ngIf="recipient?.maxMismatches">
        <label><span class="privilege-indicator"></span>Max mismatches</label>
        {{ recipient?.maxMismatches }}
      </p>
      <p *ngIf="recipient?.maxMmA">
        <label><span class="privilege-indicator"></span>Max mm A</label>
        {{ recipient?.maxMmA }}
      </p>
      <p *ngIf="recipient?.maxMmB">
        <label><span class="privilege-indicator"></span>Max mm B</label>
        {{ recipient?.maxMmB }}
      </p>
      <p *ngIf="recipient?.maxMmDR">
        <label><span class="privilege-indicator"></span>Max mm DR</label>
        {{ recipient?.maxMmDR }}
      </p>
      <p *ngIf="recipient?.maxMismatchesWarningDismissed && recipient?.maxMismatchesWarningDismissalReason" class="warning-dismissal-reason">
        <label matTooltip="This recipient has max mismatches privilege but is not in a compatible pair or younger than 18">Max mismatches reason:</label>
        {{ recipient?.maxMismatchesWarningDismissalReason }}
      </p>
      <p *ngIf="recipient?.acceptableBloodTypes">
        <label><span class="privilege-indicator"></span>Acceptable Bloodtypes</label>
        {{ formattedAcceptableBloodTypes }}
      </p>
      <p *ngIf="recipient?.acceptableBloodTypesWarningDismissed && recipient?.acceptableBloodTypesWarningDismissalReason" class="warning-dismissal-reason">
        <label matTooltip="This recipient has acceptable blood types privilege but <2 years dialysis time or missing dialysis date">Acceptable blood types reason:</label>
        {{ recipient?.acceptableBloodTypesWarningDismissalReason }}
      </p>
      <p *ngIf="recipient?.acceptableHla">
        <label><span class="privilege-indicator"></span>Delisted Unacceptables</label>
        {{ recipient?.acceptableHla }}
      </p>
      <p *ngIf="recipient?.extraWaitTime">
        <label><span class="privilege-indicator"></span>Extra wait time</label>
        {{ recipient?.extraWaitTime }}
      </p>
      <p *ngIf="recipient?.lowMfi1">
        <label><span class="privilege-indicator"></span>Low MFI unacceptables class 1 (A/B)</label>
        {{ recipient?.lowMfi1 }}
      </p>
      <p *ngIf="recipient?.lowMfi2">
        <label><span class="privilege-indicator"></span>Low MFI unacceptables class 2 (DR/DQ)</label>
        {{ recipient?.lowMfi2 }}
      </p>

      <p *ngIf="recipient?.multipleDonorWarningDismissed && recipient?.multipleDonorWarningDismissalReason" class="warning-dismissal-reason">
        <label matTooltip="This recipient has  <2 dialysis time or missing dialysis date">Multiple donor reason:</label>
        {{ recipient?.multipleDonorWarningDismissalReason }}
      </p>

      <p *ngIf="recipient?.lastUpdate">
        <label>Last updated</label>
        {{ recipient?.lastUpdate | date: "d MMM y, HH:mm:ss" }}
      </p>
    </div>
  </div>

  <!-- Donor-specific template -->
  <div *ngIf="!isRecipient">
    <!-- Inactive banner for multi-donor scenarios (only show if donor has different reason than recipient) -->
    <div class="inactive-reason" *ngIf="isMultiDonor && pair && !pair.active && shouldShowDonorInactiveBanner()">Inactive donor with reason: {{ pair.reasonInactive }}</div>

    <div class="participant-header">
      <mat-icon *ngIf="isDonorAwaitingEnisSync" [ngClass]="[pair ? 'icon-right' : 'icon', donor?.transplanted ? 'transplanted' : '']"></mat-icon>
      <mat-icon *ngIf="!isDonorAwaitingEnisSync" [ngClass]="[pair ? 'icon-right' : 'icon', donor?.transplanted ? 'transplanted' : '']" svgIcon="human-{{ donor?.gender === 'M' ? 'male' : 'female' }}"></mat-icon>
      <div class="participant-details">
        <p class="name">
          <span>
            <a *ngIf="dialogRef && !donor?.historical" [routerLink]="['/participants']" [queryParams]="{ expandId: pair?.recipient?.id || donor?.linkedRecipient?.id || donorRecipientId || donor?.id, donorId: (pair?.recipient || donor?.linkedRecipient || donorRecipientId) ? donor?.id : null }" (click)="closeDialog()">{{ donor?.firstName }} {{ donor?.lastName }}</a>
            <a *ngIf="!dialogRef || donor?.historical" [routerLink]="['/history/donor', donor?.id]" (click)="closeDialog()">{{ donor?.firstName }} {{ donor?.lastName }}</a>
            <p class="type" *ngIf="history">Donor</p>
          </span>
        </p>
                <p class="type" *ngIf="donor && !history">Donor</p>
        <p *ngIf="donor?.enisNumber">
          <label>ET Number</label>
          {{ donor?.enisNumber }}
        </p>

        <p *ngIf="donor?.altruist">
          <label>Altruist</label>
          Yes
        </p>

        <p *ngIf="donor?.altruist && donor?.active !== undefined">
          <label>Status</label>
          {{ donor?.active ? 'Active' : 'Inactive' }}
        </p>

        <p *ngIf="donor?.center">
          <label>Center</label>
          {{ donor?.center?.name }}
        </p>
        <p>
          <label>Date of birth</label>
          {{ donor?.dob | date: "d MMM y" }}
          <span class="age">({{ age }} years old)</span>
        </p>

        <p *ngIf="donor?.abo">
          <label>Blood group</label>
          {{ donor?.abo }}
        </p>
        <p *ngIf="donorHlaClassI">
          <label>HLA Class I</label>
          {{ donorHlaClassI }}
        </p>
        <p *ngIf="donorHlaClassII">
          <label>HLA Class II</label>
          {{ donorHlaClassII }}
        </p>

        <p *ngIf="donor?.limitedToCenter?.length">
          <label><span class="privilege-indicator"></span>Limited to Centers:</label>
          <span>
            <ng-container *ngFor="let center of donor?.limitedToCenter; let isLast = last"> {{ center.name }}<span *ngIf="!isLast">, </span> </ng-container>
          </span>
        </p>

        <p *ngIf="donor?.donateToWaitlist">
          <label><span class="privilege-indicator"></span>Donate to Waitlist Only</label>
          Yes
        </p>

        <p *ngIf="donor?.lastUpdate">
          <label>Last updated</label>
          {{ donor?.lastUpdate | date: "d MMM y, HH:mm:ss" }}
        </p>
      </div>
    </div>
  </div>
  <ng-container *ngIf="donor && pair">
    <div [class.inactive]="shouldGrayOut">
      <p>
        <label>Relation</label>
        {{ pair.relationToRecipient }}
      </p>
      <p>
        <label>Compatible pair:</label>
        {{ pair.compatible ? "Yes" : "No" }}
      </p>
      <p>
        <label>Participated in</label>
        {{ pair.matchingPeriodCount || 0 }} matching periods
      </p>
      <p>
        <label>Comments</label>
        {{ pair.comments || "-" }}
      </p>
    </div>
  </ng-container>

  <!-- Spacer to push locked message and action buttons to the bottom -->
  <div class="spacer"></div>

  <!-- Only show banners if not hidden (hideBanners is used in pair view).
       Hidden in history mode so the "Transplantation confirmed" banner is not shown on the historical screen. -->
  <ng-container *ngIf="!hideBanners && !history">
    <!-- For pair view: show both banners side by side -->
    <div class="banners-container" *ngIf="donor && recipient">
      <!-- Donor banner -->
      <div class="locked-message" *ngIf="isDonorLocked()">
        <mat-icon>lock</mat-icon>
        <span>{{ getDonorLockMessage() }}</span>
      </div>
      <!-- Recipient banner -->
      <div class="locked-message" *ngIf="isRecipientLocked()">
        <mat-icon>lock</mat-icon>
        <span>{{ getRecipientLockMessage() }}</span>
      </div>
    </div>

    <!-- For single participant view: show single banner -->
    <div class="locked-message" *ngIf="(!donor || !recipient) && (donor || recipient) && isParticipantLocked">
      <mat-icon>lock</mat-icon>
      <span>{{ lockMessage }}</span>
    </div>
  </ng-container>

  <!-- Show Report Transplantation button when participant is selected for transplantation -->
  <div class="action-row-container" *ngIf="canReportTransplantation()">
    <mat-action-row class="bottom-right participant-actions">
      <button
        mat-raised-button
        color="accent"
        class="transplant-button"
        (click)="onReportTransplantation()"
      >
        Confirm Transplantation
      </button>
    </mat-action-row>
  </div>

  <div class="action-row-container" *ngIf="!isParticipantLocked">
    <!-- Participant-level action buttons (Edit, Archive, Committee request, Add Privileges) -->
    <mat-action-row class="bottom-right participant-actions">
      <!-- Recipient buttons -->
      <ng-container *ngIf="recipient">
        <button
          *ngIf="canRemoveParticipant && recipient.firstName !== '*****' && canCenterUserArchiveParticipant && !pair"
          mat-button
          class="warn-button"
          (click)="onRemoveParticipant()"
        >
          Archive recipient
        </button>
        <button
          *ngIf="canAddPriorityParticipant && recipient.firstName !== '*****' && !recipient.postmortumwaitlist"
          mat-button
          class="custom-button"
          (click)="onRequestPriority()"
        >
          Committee request
        </button>

        <button
          *ngIf="canEditParticipant && recipient.firstName !== '*****' && canCenterUserEditParticipant"
          mat-button
          class="custom-button"
          (click)="onEditParticipant()"
          color="primary"
        >
          Edit recipient
        </button>
      </ng-container>

      <!-- Donor buttons -->
      <ng-container *ngIf="donor && !recipient">
        <button
          *ngIf="canRemoveParticipant && donor.firstName !== '*****' && canCenterUserArchiveParticipant && !pair"
          mat-button
          class="warn-button"
          (click)="onRemoveParticipant()"
        >
          Archive donor
        </button>
        <button
          *ngIf="canEditParticipant && donor.firstName !== '*****' && canCenterUserEditParticipant"
          mat-button
          class="custom-button"
          (click)="onEditParticipant()"
          color="primary"
        >
          Edit donor
        </button>
      </ng-container>
    </mat-action-row>
  </div>
</div>
